export default __webpack_public_path__ + "static/media/card-pickus.584b7788.jpg";